function compareNullable<T>(
  a: T | null | undefined,
  b: T | null | undefined,
  comparer: (a: T, b: T) => number
): number {
  if (a == null && b == null) return 0;
  if (a == null) return 1;
  if (b == null) return -1;

  return comparer(a, b);
}

export function compareStrings(
  a?: string | null,
  b?: string | null
): number {
  return compareNullable(a, b, (x, y) =>
    x.localeCompare(y, undefined, {
      sensitivity: 'base',
    })
  );
}

export function compareNumbers(
  a?: number | null,
  b?: number | null
): number {
  return compareNullable(a, b, (x, y) => x - y);
}

export function compareBooleans(
  a?: boolean | null,
  b?: boolean | null
): number {
  return compareNullable(a, b, (x, y) => Number(x) - Number(y));
}

export function compareDates(
  a?: Date | string | null,
  b?: Date | string | null
): number {
  return compareNullable(a, b, (x, y) => {
    const aTime = new Date(x).getTime();
    const bTime = new Date(y).getTime();

    return aTime - bTime;
  });
}